import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { mockTools } from './data/mockTools';
import { useCart } from './context/CartContext';
import './styles/Marketplace.css';

const ITEMS_PER_PAGE = 12;

const MarketplaceCmp = () => {
    const navigate = useNavigate();
    const { addToCart } = useCart();
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [isProcessing, setIsProcessing] = useState(false);

    // Only show products/tools in the marketplace
    const filteredTools = useMemo(() => {
        return mockTools.filter(tool => {
            const matchesSearch = tool.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                tool.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
                tool.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase()));
            return matchesSearch;
        });
    }, [searchQuery]);

    const paginatedTools = useMemo(() => {
        const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
        return filteredTools.slice(startIndex, startIndex + ITEMS_PER_PAGE);
    }, [filteredTools, currentPage]);

    const totalPages = Math.ceil(filteredTools.length / ITEMS_PER_PAGE);

    const handleAddToCart = (tool) => {
        addToCart(tool);
    };

    const handleToolClick = (toolId) => {
        navigate(`/business-tool-marketplace/tool/${toolId}`);
    };

    return (
        <div className='marketplace-container'>
            <div className="marketplace">
                <div className="marketplace-header">
                    <h1>Business Tools Marketplace</h1>
                    <div className="filters">
                        <input
                            type="text"
                            placeholder="Search tools or creators..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="search-input"
                        />
                        {/* Only 'All' for now */}
                    </div>
                </div>

                <div className="tools-grid">
                    {paginatedTools.map(tool => (
                        <div key={tool.id} className="tool-card">
                            {tool.imageUrl && (
                                <img
                                    src={tool.imageUrl}
                                    alt={tool.title}
                                    className="tool-image"
                                    onClick={() => handleToolClick(tool.id)}
                                />
                            )}
                            <div className="tool-info">
                                <h3 className="tool-title" onClick={() => handleToolClick(tool.id)}>
                                    {tool.title}
                                </h3>
                                <div className="result-label" style={{ color: 'var(--color-text-secondary)', fontSize: '0.85rem', background: 'var(--color-input)', borderRadius: '999px', padding: '0.25rem 0.75rem', margin: '0.25rem 0 0.75rem 0', display: 'inline-block' }}>Product</div>
                                <div className="tool-description">{tool.description}</div>
                                <div className="tool-author">By {tool.author}</div>
                                <div className="tool-tags">
                                    {tool.tags.map(tag => (
                                        <span key={tag} className="tool-tag">{tag}</span>
                                    ))}
                                </div>
                                <div className="tool-bottom">
                                    <span className="tool-price">
                                        ${tool.price.toFixed(2)}
                                    </span>
                                    <button
                                        className="add-to-cart"
                                        onClick={() => handleAddToCart(tool)}
                                        disabled={isProcessing}
                                    >
                                        Add to Cart
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {totalPages > 1 && (
                    <div className="pagination">
                        <button
                            className="button button-secondary"
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                        >
                            Previous
                        </button>
                        <span>Page {currentPage} of {totalPages}</span>
                        <button
                            className="button button-secondary"
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MarketplaceCmp;